// The glasses prescription and the eye examination, as the visit form, the
// visit history, the optician's queue and the printed slip all lay them out.
// Keep in step with backend/utils/glassesSpec.js.

// One row per eye: [field prefix, translation key, fallback].
export const EYES = [
    ['right', 'rightEye', 'Right eye (OD)'],
    ['left', 'leftEye', 'Left eye (OS)']
];

// The columns of a glasses prescription: [field suffix, label, placeholder].
// The labels are the ones printed on every prescription pad, in every
// language, so they are not translated.
export const POWER_COLUMNS = [
    ['Sph', 'SPH', '-1.25'],
    ['Cyl', 'CYL', '-0.50'],
    ['Axis', 'AXIS', '180'],
    ['Add', 'ADD', '+2.00']
];

// The columns of the eye examination: [field suffix, translation key, fallback, placeholder].
export const EXAM_COLUMNS = [
    ['Va', 'visualAcuity', 'Visual acuity', '6/6'],
    ['Bcva', 'correctedAcuity', 'Corrected acuity', '6/6'],
    ['Iop', 'eyePressure', 'IOP (mmHg)', '15']
];

const MEASUREMENT_KEYS = [
    ...EYES.flatMap(([eye]) => POWER_COLUMNS.map(([suffix]) => `${eye}${suffix}`)),
    'pd'
];

const filled = (value) => value !== null && typeof value !== 'undefined' && String(value).trim() !== '';

// Is there anything here to make glasses from? A note or a lens type alone is
// not a prescription.
export const hasGlassesSpec = (glasses) => MEASUREMENT_KEYS.some((key) => filled(glasses?.[key]));

export const hasEyeExam = (eyeExam) => Object.values(eyeExam || {}).some(filled);

export const hasDental = (dental) => Object.values(dental || {}).some(filled);

export const ORDER_STATUS_COLORS = {
    new: 'orange',
    in_progress: 'blue',
    ready: 'green',
    delivered: 'default',
    cancelled: 'red'
};

// [translation key, fallback] for each status.
export const ORDER_STATUS_LABELS = {
    new: ['glassesNew', 'New'],
    in_progress: ['glassesInProgress', 'In progress'],
    ready: ['glassesReady', 'Ready'],
    delivered: ['glassesDelivered', 'Delivered'],
    cancelled: ['glassesCancelled', 'Cancelled']
};

// i18next hands back the key itself when a string is missing, so `t(key) ||
// fallback` never reaches the fallback.
export const translate = (t, key, fallback) => {
    const value = t ? t(key) : null;
    return value && value !== key ? value : fallback;
};

export const orderStatusLabel = (t, status) => {
    const [key, fallback] = ORDER_STATUS_LABELS[status] || [status, status];
    return translate(t, key, fallback);
};
